// extracted by mini-css-extract-plugin
export var activeDot = "_98-c";
export var buttonContainer = "_98-9";
export var channelButton = "_98-a";
export var clickable = "_98-d";
export var content = "_98-0";
export var contentFull = "_98-2";
export var contentThird = "_98-1";
export var contentWrapper = "_98-7";
export var description = "_98-5";
export var heightShort = "_98-f";
export var image = "_98-3";
export var imageContainer = "_98-4";
export var selectButton = "_98-e";
export var spinnerContainer = "_98-b";
export var titleContent = "_98-8";
export var titleWrapper = "_98-6";